// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 774 ? "72a92d46" : chunkId) + "." + {"774":"8286b7f25cfca157","952":"331b961af841f34a"}[chunkId] + ".js";
};